import * as ambassadorWixEmailsTransmissionsV1EmailTransmission from './emails-transmissions-v1-email-transmission-email-transmissions.http.js';
import * as ambassadorWixEmailsTransmissionsV1EmailTransmissionTypes from './emails-transmissions-v1-email-transmission-email-transmissions.types.js';
import * as ambassadorWixEmailsTransmissionsV1EmailTransmissionUniversalTypes from './emails-transmissions-v1-email-transmission-email-transmissions.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function sendEmailTransmission(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixEmailsTransmissionsV1EmailTransmissionUniversalTypes.SendEmailTransmissionRequest,
  ambassadorWixEmailsTransmissionsV1EmailTransmissionTypes.SendEmailTransmissionRequest,
  ambassadorWixEmailsTransmissionsV1EmailTransmissionUniversalTypes.SendEmailTransmissionResponse,
  ambassadorWixEmailsTransmissionsV1EmailTransmissionTypes.SendEmailTransmissionResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixEmailsTransmissionsV1EmailTransmission.sendEmailTransmission(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/email-transmissions/send',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getEmailTransmission(): __PublicMethodMetaInfo<
  'GET',
  { emailTransmissionId: string },
  ambassadorWixEmailsTransmissionsV1EmailTransmissionUniversalTypes.GetEmailTransmissionRequest,
  ambassadorWixEmailsTransmissionsV1EmailTransmissionTypes.GetEmailTransmissionRequest,
  ambassadorWixEmailsTransmissionsV1EmailTransmissionUniversalTypes.GetEmailTransmissionResponse,
  ambassadorWixEmailsTransmissionsV1EmailTransmissionTypes.GetEmailTransmissionResponse
> {
  const payload = { emailTransmissionId: ':emailTransmissionId' } as any;

  const getRequestOptions =
    ambassadorWixEmailsTransmissionsV1EmailTransmission.getEmailTransmission(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/email-transmissions/{emailTransmissionId}',
    pathParams: { emailTransmissionId: 'emailTransmissionId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function queryEmailTransmissions(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixEmailsTransmissionsV1EmailTransmissionUniversalTypes.QueryEmailTransmissionsRequest,
  ambassadorWixEmailsTransmissionsV1EmailTransmissionTypes.QueryEmailTransmissionsRequest,
  ambassadorWixEmailsTransmissionsV1EmailTransmissionUniversalTypes.QueryEmailTransmissionsResponse,
  ambassadorWixEmailsTransmissionsV1EmailTransmissionTypes.QueryEmailTransmissionsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixEmailsTransmissionsV1EmailTransmission.queryEmailTransmissions(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/email-transmissions/query',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function deleteEmailTransmission(): __PublicMethodMetaInfo<
  'DELETE',
  { emailTransmissionId: string },
  ambassadorWixEmailsTransmissionsV1EmailTransmissionUniversalTypes.DeleteEmailTransmissionRequest,
  ambassadorWixEmailsTransmissionsV1EmailTransmissionTypes.DeleteEmailTransmissionRequest,
  ambassadorWixEmailsTransmissionsV1EmailTransmissionUniversalTypes.DeleteEmailTransmissionResponse,
  ambassadorWixEmailsTransmissionsV1EmailTransmissionTypes.DeleteEmailTransmissionResponse
> {
  const payload = { emailTransmissionId: ':emailTransmissionId' } as any;

  const getRequestOptions =
    ambassadorWixEmailsTransmissionsV1EmailTransmission.deleteEmailTransmission(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'DELETE',
    path: '/v1/email-transmissions/{emailTransmissionId}',
    pathParams: { emailTransmissionId: 'emailTransmissionId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  EmailTransmission as EmailTransmissionOriginal,
  EmailTransmissionTypeOptionsOneOf as EmailTransmissionTypeOptionsOneOfOriginal,
  EmailTransmissionStatusOptionsOneOf as EmailTransmissionStatusOptionsOneOfOriginal,
  Recipient as RecipientOriginal,
  RecipientValueOneOf as RecipientValueOneOfOriginal,
  RecipientStatus as RecipientStatusOriginal,
  RecipientStatusWithLiterals as RecipientStatusWithLiteralsOriginal,
  FailureReason as FailureReasonOriginal,
  FailureReasonWithLiterals as FailureReasonWithLiteralsOriginal,
  Type as TypeOriginal,
  TypeWithLiterals as TypeWithLiteralsOriginal,
  MarketingOptions as MarketingOptionsOriginal,
  Status as StatusOriginal,
  StatusWithLiterals as StatusWithLiteralsOriginal,
  RejectedOptions as RejectedOptionsOriginal,
  RejectionReason as RejectionReasonOriginal,
  RejectionReasonWithLiterals as RejectionReasonWithLiteralsOriginal,
  GetLiveEmailTransmissionRequest as GetLiveEmailTransmissionRequestOriginal,
  GetLiveEmailTransmissionResponse as GetLiveEmailTransmissionResponseOriginal,
  GetDeletedEmailTransmissionRequest as GetDeletedEmailTransmissionRequestOriginal,
  GetDeletedEmailTransmissionResponse as GetDeletedEmailTransmissionResponseOriginal,
  QueryLiveEmailTransmissionsRequest as QueryLiveEmailTransmissionsRequestOriginal,
  CursorQuery as CursorQueryOriginal,
  CursorQueryPagingMethodOneOf as CursorQueryPagingMethodOneOfOriginal,
  Sorting as SortingOriginal,
  SortOrder as SortOrderOriginal,
  SortOrderWithLiterals as SortOrderWithLiteralsOriginal,
  CursorPaging as CursorPagingOriginal,
  QueryLiveEmailTransmissionsResponse as QueryLiveEmailTransmissionsResponseOriginal,
  CursorPagingMetadata as CursorPagingMetadataOriginal,
  Cursors as CursorsOriginal,
  QueryDeletedEmailTransmissionsRequest as QueryDeletedEmailTransmissionsRequestOriginal,
  QueryDeletedEmailTransmissionsResponse as QueryDeletedEmailTransmissionsResponseOriginal,
  DomainEvent as DomainEventOriginal,
  DomainEventBodyOneOf as DomainEventBodyOneOfOriginal,
  EntityCreatedEvent as EntityCreatedEventOriginal,
  RestoreInfo as RestoreInfoOriginal,
  EntityUpdatedEvent as EntityUpdatedEventOriginal,
  EntityDeletedEvent as EntityDeletedEventOriginal,
  ActionEvent as ActionEventOriginal,
  MessageEnvelope as MessageEnvelopeOriginal,
  IdentificationData as IdentificationDataOriginal,
  IdentificationDataIdOneOf as IdentificationDataIdOneOfOriginal,
  WebhookIdentityType as WebhookIdentityTypeOriginal,
  WebhookIdentityTypeWithLiterals as WebhookIdentityTypeWithLiteralsOriginal,
  AccountInfo as AccountInfoOriginal,
  SendEmailTransmissionRequest as SendEmailTransmissionRequestOriginal,
  SendEmailTransmissionResponse as SendEmailTransmissionResponseOriginal,
  AccountSuspendedErrorDetails as AccountSuspendedErrorDetailsOriginal,
  OutOfQuotaErrorDetails as OutOfQuotaErrorDetailsOriginal,
  GetEmailTransmissionRequest as GetEmailTransmissionRequestOriginal,
  GetEmailTransmissionResponse as GetEmailTransmissionResponseOriginal,
  QueryEmailTransmissionsRequest as QueryEmailTransmissionsRequestOriginal,
  QueryEmailTransmissionsResponse as QueryEmailTransmissionsResponseOriginal,
  DeleteEmailTransmissionRequest as DeleteEmailTransmissionRequestOriginal,
  DeleteEmailTransmissionResponse as DeleteEmailTransmissionResponseOriginal,
  Empty as EmptyOriginal,
  SendEmailTransmissionApplicationErrors as SendEmailTransmissionApplicationErrorsOriginal,
  SendEmailTransmissionValidationErrors as SendEmailTransmissionValidationErrorsOriginal,
  DeleteEmailTransmissionApplicationErrors as DeleteEmailTransmissionApplicationErrorsOriginal,
} from './emails-transmissions-v1-email-transmission-email-transmissions.types.js';
